import React, { useEffect, useState } from 'react';
import GeoclientAuth from './GeoclientAuth';
import GeoclientTours from './GeoclientTours';
import GeoclientQuotes from './GeoclientQuotes';
import { GeoclientApi } from '../../../api/GeoclientApi';

const GeoclientPopup = (props) => {
  const [isAuth, setIsAuth] = useState(props.isAuth);
  const [token, setToken] = useState(props.token);
  const [isOpenQuotes, setIsOpenQuotes] = useState(false);
  const [quotes, setQuotes] = useState([]);
  const [isQuotesLoading, setQuotesLoading] = useState(false);
  const [isQuotesLoadingErr, setQuotesLoadingErr] = useState(false);

  useEffect(() => {
    setQuotesLoadingErr(false);
    if (quotes.length !== 0) {
      return;
    } else {
      getQuotes();
    }
  }, [quotes, isOpenQuotes]);

  function getQuotes() {
    setQuotesLoadingErr(false);
    setQuotesLoading(true);
    GeoclientApi.getQuotes(token)
      .then((res) => {
        setQuotes([]);
        setQuotes(res.response.results);
        setQuotesLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setQuotesLoading(false);
        setQuotesLoadingErr(true);
      });
  }

  const handleAuth = (auth, user, token) => {
    setIsAuth(auth);
    setToken(token);
    props.onAuth(auth, user, token);
  };

  return (
    <div className="geoclient__wrapper__popup">
      <GeoclientAuth
        isAuth={props.isAuth}
        onAuth={handleAuth}
        setQuotes={setQuotes}
        onLogout={props.handleLogout}
      />
      {isAuth ? (
        <>
          <GeoclientTours
            {...props}
            getQuotes={getQuotes}
            isQuoteEdit={props.isQuoteEdit}
          />
          <button
            className="geoclient__quotes-open-close"
            onClick={() => setIsOpenQuotes(!isOpenQuotes)}
          >
            {!isOpenQuotes ? 'Показать мои подборки' : 'Скрыть мои подборки'}
          </button>
          {isOpenQuotes && (
            <GeoclientQuotes
              token={token}
              quotes={quotes}
              isLoading={isQuotesLoading}
              isLoadingErr={isQuotesLoadingErr}
              onQuoteEdit={props.handleQuoteEdit}
              getQuoteInfo={props.getQuoteInfo}
            />
          )}
        </>
      ) : null}
    </div>
  );
};

export default GeoclientPopup;
